export default "__VITE_ASSET__000150cd__"